<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.schedules', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex justify-end">
            <form action="" @submit.prevent="submit">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </form>
        </div>

        <ScheduleMaker :groups="groups" :subjects="subjects" :teachers="teachers" v-model="form.schedule" />

        <div class="flex justify-end">
            <form action="" @submit.prevent="submit">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </form>
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ScheduleMaker from '@/components/pageSpecific/ScheduleMaker.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        ScheduleMaker,
    },
    layout: AdminLayout,
    name: 'Create',
    props: ['meta', 'groups', 'subjects', 'teachers', 'stage_id', 'schedule'],
    data() {
        return {
            form: this.$inertia.form({
                stage_id: this.stage_id,
                schedule: this.schedule,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store, {
                preserveScroll: true,
            });
        },
    },
};
</script>
